/**
 * True when a keyboard event's target is a text-entry surface — a native
 * input/textarea/select or a contenteditable node.
 *
 * Global keyboard shortcuts use this to bow out while the user is typing, so a
 * single-key or Cmd/Ctrl chord cannot steal input from a field or clash with an
 * editor's own binding (for example Tiptap's `Mod-b`, which a contenteditable
 * handles and lets bubble).
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  const element = target as HTMLElement | null
  if (!element) return false
  if (element.isContentEditable) return true
  return /^(INPUT|TEXTAREA|SELECT)$/.test(element.tagName)
}
